import Vue from "vue";
import { findInFormAnswer } from "./find_in_form_answer.js";

export class ScoreFormInput {
  constructor(data, special_type) {
    this.type = "score";
    this.special_type = special_type;
    this.data = data || {
      required: false,
      question: "",
    };
  }
}

export let ScoreFormInputComponent = Vue.extend({
  props: ["input"],
  template: "#score-form-input-template",
  data: function () {
    return {
      trainee_answer: "",
    };
  },
  created: function () {
    const answer = findInFormAnswer(this.input);
    if (answer !== undefined) {
      this.trainee_answer = answer;
    }
  },
  methods: {
    answer: function (val) {
      this.trainee_answer = val;
    },
  },
  watch: {
    trainee_answer: function () {
      this.$root.onTraineeAnswer(this);
    },
  },
});
